//src/pages/matching-intergenerationnel/QuestionnaireRedirect.tsx
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const VISION_BASE =
  process.env.REACT_APP_VISION_URL ||
  "https://vision.artkiv.com";

export default function QuestionnaireRedirect() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  useEffect(() => {
    const url = `${VISION_BASE}/matching-intergenerationnel/questionnaire?token=${encodeURIComponent(token)}`;
    window.location.replace(url);
  }, [token]);

  return null;
}

